import React from 'react';

import { Card } from './Card.styles';

const CardComponent = ({ children, ...props }) => {
	return <Card {...props}>{children}</Card>;
};

export default CardComponent;
